import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function CategoriesTitle({ page }) {
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const navbarCategory = useSelector(({ navigation }) => navigation.navbarCategory);
    const basenameURL = useSelector(({ language }) => language.basenameURL);

    return (
        <section style={{ backgroundColor: '#7e7e7e', paddingTop: 20, paddingBottom: 20 }}>
            <div className='container relative clearfix'>
                <ol className='breadcrumb'>
                    <li>
                        <Link to={`${basenameURL}`}>
                            {currentLanguage === 'TH'
                                ? navbarCategory[0]?.categoriesNameTh
                                : navbarCategory[0]?.categoriesNameEn}
                        </Link>
                    </li>
                    <li className='active'>{page}</li>
                </ol>
            </div>
        </section>
    );
}
